export const config = {
  API_BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:8080',
  APP_NAME: process.env.REACT_APP_APP_NAME || 'Cenadz Gym Management System'
}; 
